// extracted by mini-css-extract-plugin
export default {"error":"ErrorBoundary_error__-4eD1","error__wrapper":"ErrorBoundary_error__wrapper__dw3Yk"};